import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42ecebc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "mt-4 grid grid-cols-1 gap-1" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Дата РПП:", -1))
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Стоимость перевозки:", -1))
const _hoisted_12 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Номер рейса:", -1))
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Стоимость без НДС:", -1))
const _hoisted_17 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_18 = { class: "flex items-center gap-2 font-semibold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Перевозчик:", -1))
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Номер акта:", -1))
const _hoisted_22 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Направление:", -1))
const _hoisted_25 = { class: "flex items-center gap-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Дата акта:", -1))
const _hoisted_27 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_28 = { class: "flex items-center gap-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Логист:", -1))
const _hoisted_30 = { class: "mt-2 flex items-center justify-end gap-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["RppLtlListItem", { 'bg-red-50': _ctx.item.isAboveCostStandard, 'bg-white': !_ctx.item.isAboveCostStandard }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.item.statusId === 11)
            ? (_openBlock(), _createBlock(_component_checkbox, {
                key: 0,
                value: _ctx.isSelected,
                onChange: _ctx.onSelect
              }, null, 8, ["value", "onChange"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: "text-blue-500 font-semibold",
            to: `/rpp/ltl/${_ctx.item.id}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode("РПП №" + _toDisplayString(_ctx.item.pbsNumber), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_cheap, { class: "small blue--fill" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.costPerWeight) + " тг/кг", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_cheap, { class: "small blue--fill" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.costPerVolume) + " тг/м³", 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small", {
                        green: _ctx.item.statusId === 15,
                        yellow: _ctx.item.statusId === 13,
                        red: _ctx.item.statusId === 11,
                    }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.statusName || 'Нет статуса'), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.item.pbsDate)), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.costOfTransportation), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_router_link, {
            class: "text-blue-500 font-semibold",
            to: `/tms/trips/${_ctx.item.tripId}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.tripNumber), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.costOfTransportationWithoutNds), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.carrier), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.actNumber || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.direction), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.item.actDate)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.logist || '-'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      (_ctx.item.statusId === 13 || _ctx.item.statusId === 15)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "small primary",
            onClick: _ctx.onUpdate
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              _createTextVNode(" Редактировать ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.item.statusId === 11)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            class: "small primary ml-2",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Подтвердить ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.item.statusId === 15)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 2,
            class: "small primary",
            loading: _ctx.state.is_trip_print_loading,
            onClick: _ctx.printTrip
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Распечатать рейс ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.item.statusId === 15)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 3,
            class: "small primary ml-2",
            onClick: _ctx.printRpp,
            loading: _ctx.state.is_loading,
            disabled: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Распечатка ")
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}